import React from 'react';
import PermissionsTab from './PermissionsTab';

export default function PermissionsPage() {
  return <PermissionsTab />;
}
